import React from 'react';
import PropTypes from 'prop-types';

const QuestionRow = (props) => {
  const {
    row,
    onRemove,
    onActivate,
    showAllMode = false,
    checkboxMode = false,
    renderTrashBtn,
    renderGoalLabel,
    renderQuestion
  } = props;

  const cssBem = 'questionBuilder';

  const renderedQuestions = row.questions.map((question, index) => {
    return showAllMode || row.active ?
      <div className={`${cssBem}__question`} key={`${row.id}_${index}`}>
        {renderQuestion(question)}
      </div>
      : null;
  });

  const checkboxModeTrigger = () => {
    if (!row.active) {
      onActivate();
    } else {
      onRemove();
    }
  };

  const rowTrigger = checkboxMode ? <input className={`${cssBem}__rowTrigger`} type="checkbox" id={`${row.id}-trigger`} onChange={checkboxModeTrigger} checked={!!(checkboxMode && row.active)}/> : null;
  const removeButton = <button className={`${cssBem}__rowRemoveBtn`} onClick={onRemove}>{renderTrashBtn}</button>;
  const checkedClass = checkboxMode && row.active ? 'row-selected' : '';

  return <div className={`${cssBem}__row ${checkedClass}`} id={`questionBuilderRow-${row.id}`}>
    <div className={`${cssBem}__question row-key`}>
      <label className={`${cssBem}__label`}>{renderGoalLabel}</label>
      <div className={`${cssBem}__text`}>{ checkboxMode ? <label>{rowTrigger}{row.label}</label> : row.label }</div>
    </div>
    {renderedQuestions}
    {removeButton}
  </div>;
};
QuestionRow.propTypes = {
  isToggle: PropTypes.bool.isRequired,
  showAllMode: PropTypes.bool,
  checkboxMode: PropTypes.bool,
  onRemove: PropTypes.func,
  onActivate: PropTypes.func
};

export default QuestionRow;
